(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('SessionConfirmationController', SessionConfirmationController);


    SessionConfirmationController.$inject = ['$scope', 'Principal','$state','$rootScope','$localStorage', '$sessionStorage','$timeout', 'Auth', 'AuthTrackerProvider','AuthServerProvider'];

    function SessionConfirmationController ($scope, Principal,$state,$rootScope,$localStorage,$sessionStorage,$timeout, Auth, AuthTrackerProvider,AuthServerProvider) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.sessionConfirmation = sessionConfirmation;
        vm.registerAccount = {};
        vm.success = null;
        vm.sessionContinue=sessionContinue;
        vm.sessionCancel=sessionCancel;
        vm.account =null;
        vm.isNavbarCollapsed = false;
        
       // $timeout(function (){angular.element('#login').focus();});
      
        var isAuthenticated = Principal.isAuthenticated();
        if(!isAuthenticated){
        	$state.go('login');
        }else{
        	var duplicateLogins=$sessionStorage.sessionConfrimation;
        	//alert("duplicateLogins :"+duplicateLogins);
        	if(duplicateLogins != 'duplicateLogins'){
        		$state.go('home');
        	}
        }
        
      // var ses=$sessionStorage.sessionConfrimation;
        
      // alert("ses :"+ses);
      /*  collapseNavbar();
        
        function collapseNavbar() {
        	alert("nav bar");
            vm.isNavbarCollapsed = true;
        }*/
        
        
      
        
        
        
        function sessionContinue(){
        	//alert("sessionContinue ");
        	
        	AuthTrackerProvider.continueWithCurrentSession().then(function(response){
            	var sucussRes=response.data[0];
            	
            	if(sucussRes=='Success'){
            		
            		$timeout(function(){$rootScope.duplicatehideflag = false;},10);
            		delete $sessionStorage.sessionConfrimation;
            		 $state.go('home');
                     $rootScope.$broadcast('authenticationSuccess');
                     
            	}else{
            		delete $sessionStorage.sessionConfrimation;
            		 $state.go('home');
                     $rootScope.$broadcast('authenticationSuccess');
            	}
            	
            	
            });
        }
        
        function sessionCancel(){
        	//alert("sessionCancel ");
        	AuthTrackerProvider.cancelCurrentSession().then(function(response){
            	var sucussRes=response.data[0];
            	
            	if(sucussRes=='Success'){
            		
            		  Auth.logout();
            		 $state.go('login');
            	}else{
            	
            		  Auth.logout();
            		 $state.go('login');
            	}
            	
            	
            });
        	
        }
        
        
        
        function sessionConfirmation() {
        	
        	
        	/*if (vm.registerAccount.password !== vm.confirmPassword) {
        		vm.doNotMatch = 'ERROR';
        	} else {
        		vm.registerAccount.langKey =  'en' ;
        		vm.doNotMatch = null;
        		vm.error = null;
        		vm.errorUserExists = null;
        		vm.errorEmailExists = null;
        		
        		Auth.createAccount(vm.registerAccount).then(function () {
        			vm.success = 'OK';
        		}).catch(function (response) {
        			vm.success = null;
        			if (response.status === 400 && response.data === 'login already in use') {
        				vm.errorUserExists = 'ERROR';
        			} else if (response.status === 400 && response.data === 'e-mail address already in use') {
        				vm.errorEmailExists = 'ERROR';
        			} else {
        				vm.error = 'ERROR';
        			}
        		});
        	}*/
        	
        	
        	
        }
    }
})();
